import { observer } from 'mobx-react-lite';
import { css, cssVar, HStack, NavItem, styled } from '@cad-arc';
import { FR_DEX_WINDOW_PATH } from '../../router/constants';
import { NotificationCounter } from '../../common/components/notification-counter';
import { NavLink } from '../fr-navigation';
import { getNavigationNotificationsStyle } from './helpers';
import { useDexNotification } from '../../data-exchange/use-dex-notification';
import { colors } from '../../colors/colors';

const NavItemUrgent = styled(NavItem)<{ $isUrgent: boolean; isActive: boolean }>`
    margin-top: 0;
    margin-bottom: 8px;

    & svg {
        width: 24px;
        height: 24px;
    }

    ${({ $isUrgent, isActive }) => css`
        ${$isUrgent &&
        css`
            background-color: ${colors.dexNavUrgentBackground};
            &:before {
                background-color: ${colors.dexNavUrgentBackground};
            }
            &:hover:before,
            &:hover {
                background-color: ${colors.dexNavUrgentHover};
            }
        `}

        border: 1px solid ${isActive ? cssVar('arc.colors.selected.default') : 'transparent'};
    `}
`;

export const DexNavItem = observer(function DexNavItem({ label }: { label?: string }) {
    const { count = 0, isUrgent } = useDexNotification();

    return (
        <NavLink to={FR_DEX_WINDOW_PATH}>
            {({ isActive }) => (
                <HStack position="relative">
                    <NavItemUrgent
                        as="span"
                        icon="Dex"
                        label={label}
                        isActive={isActive}
                        $isUrgent={isUrgent}
                        data-testid="dex-link-nav"
                    />
                    <NotificationCounter
                        isUrgent={isUrgent}
                        button="dex-results"
                        style={getNavigationNotificationsStyle(count)}
                    >
                        {count}
                    </NotificationCounter>
                </HStack>
            )}
        </NavLink>
    );
});
